import React from 'react';
const STATUS_LABELS = {
  open: 'Abierto',
  in_progress: 'En progreso',
  resolved: 'Resuelto',
};

const TYPE_LABELS = {
  support: 'Consulta',
  bug: 'Error',
};

const PRIORITY_LABELS = {
  low: 'Baja',
  medium: 'Media',
  high: 'Alta',
};

const formatDateTime = value => {
  if (!value) return '';
  try {
    return new Intl.DateTimeFormat('es-MX', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    }).format(new Date(value));
  } catch (error) {
    return value;
  }
};

export default function TicketsList({ tickets = [], loading = false, error = '', onRefresh }) {
  if (loading) {
    return (
      <div className="support-ticket-state">
        <span className="support-ticket-spinner" aria-hidden="true" />
        <p>Cargando tus tickets…</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="support-ticket-state">
        <p className="support-alert error">{error}</p>
        {typeof onRefresh === 'function' ? (
          <button type="button" className="support-secondary" onClick={onRefresh}>
            Reintentar
          </button>
        ) : null}
      </div>
    );
  }

  if (!tickets.length) {
    return (
      <div className="support-ticket-state support-ticket-state--empty">
        <p className="support-empty">Aun no registras tickets. Cuando envies uno aparecera aqui.</p>
      </div>
    );
  }

  return (
    <div className="support-ticket-board">
      <div className="support-ticket-table-card">
        <table className="support-ticket-table">
          <thead>
            <tr>
              <th scope="col">Estado</th>
              <th scope="col">Detalle</th>
              <th scope="col">Tipo</th>
              <th scope="col">Prioridad</th>
              <th scope="col">Fechas</th>
            </tr>
          </thead>
          <tbody>
            {tickets.map(ticket => {
              const statusKey = ticket.status || 'open';
              const statusLabel = STATUS_LABELS[statusKey] || statusKey;
              const typeLabel = TYPE_LABELS[ticket.ticketType] || ticket.ticketType || 'General';
              const priorityLabel = PRIORITY_LABELS[ticket.priority] || ticket.priority || '';
              const resolvedAt = ticket.resolvedAt || '';
              const updatedAt = ticket.updated || '';
              const lastUpdate = resolvedAt || updatedAt;
              const hasPriority = Boolean(priorityLabel);

              return (
                <tr key={ticket.id}>
                  <td data-label="Estado">
                    <span className={`support-status status-${statusKey}`}>{statusLabel}</span>
                  </td>
                  <td data-label="Detalle">
                    <div className="support-ticket-table-title">{ticket.subject || 'Sin asunto'}</div>
                    {ticket.description ? (
                      <p className="support-ticket-snippet" title={ticket.description}>
                        {ticket.description}
                      </p>
                    ) : null}
                    {ticket.description ? (
                      <span className="support-ticket-more" title="Ver descripcion completa">
                        Ver más
                      </span>
                    ) : null}
                  </td>
                  <td data-label="Tipo">
                    <span className="support-ticket-chip">{typeLabel}</span>
                  </td>
                  <td data-label="Prioridad">
                    {hasPriority ? (
                      <span className="support-ticket-chip support-ticket-chip--neutral">
                        {priorityLabel}
                      </span>
                    ) : (
                      <span className="support-ticket-text">—</span>
                    )}
                  </td>
                  <td data-label="Fechas" className="support-ticket-date-cell">
                    <time className="support-ticket-date" dateTime={ticket.created}>
                      {formatDateTime(ticket.created)}
                    </time>
                    {lastUpdate && lastUpdate !== ticket.created ? (
                      <span className="support-ticket-date-secondary">
                        {resolvedAt
                          ? `Resuelto: ${formatDateTime(resolvedAt)}`
                          : `Actualizado: ${formatDateTime(lastUpdate)}`}
                      </span>
                    ) : null}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
